// extracted by mini-css-extract-plugin
module.exports = {"paymentcont":"payment_paymentcont__CA6ZX","paymentbutton":"payment_paymentbutton__1GJdD"};